// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-container {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-content {
  max-width: 100%;
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
}

.illustration {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.illustration img {
  max-width: 100%;
  height: 100%;
  object-fit: contain;
}

.text-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.text-content h1 {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text-primary);
}

.text-content p {
  font-size: 1rem;
  color: var(--text-secondary);
}

/* Spinner Animation */
.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(32, 178, 170, 0.2);
  border-radius: 50%;
  border-top-color: var(--primary-color);
  animation: spin 1s ease-in-out infinite;
  margin-top: 1rem;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .loading-content {
    max-width: 100%;
    padding: 0 1rem;
  }

  .text-content h1 {
    font-size: 1.25rem;
  }

  .text-content p {
    font-size: 0.875rem;
  }

  .illustration {
    height: 200px;
  }
}

@media (max-width: 480px) {
  .illustration {
    height: 150px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/selectedSessionComponent/NoSummary.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,sCAAsC;EACtC,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".loading-container {\r\n  height: 100%;\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.loading-content {\r\n  max-width: 100%;\r\n  width: 100%;\r\n  text-align: center;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 2rem;\r\n}\r\n\r\n.illustration {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.illustration img {\r\n  max-width: 100%;\r\n  height: 100%;\r\n  object-fit: contain;\r\n}\r\n\r\n.text-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n\r\n.text-content h1 {\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.text-content p {\r\n  font-size: 1rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n/* Spinner Animation */\r\n.spinner {\r\n  width: 40px;\r\n  height: 40px;\r\n  border: 3px solid rgba(32, 178, 170, 0.2);\r\n  border-radius: 50%;\r\n  border-top-color: var(--primary-color);\r\n  animation: spin 1s ease-in-out infinite;\r\n  margin-top: 1rem;\r\n}\r\n\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n  .loading-content {\r\n    max-width: 100%;\r\n    padding: 0 1rem;\r\n  }\r\n\r\n  .text-content h1 {\r\n    font-size: 1.25rem;\r\n  }\r\n\r\n  .text-content p {\r\n    font-size: 0.875rem;\r\n  }\r\n\r\n  .illustration {\r\n    height: 200px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .illustration {\r\n    height: 150px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
